import { render, staticRenderFns } from "./SemaforoConAlertas.vue?vue&type=template&id=7e654248&scoped=true"
import script from "./SemaforoConAlertas.vue?vue&type=script&lang=js"
export * from "./SemaforoConAlertas.vue?vue&type=script&lang=js"
import style0 from "./SemaforoConAlertas.vue?vue&type=style&index=0&id=7e654248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e654248",
  null
  
)

export default component.exports